//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "table-cell-wordBreak-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};